interface LightboxImage {
  alt?: string;
  description: string | undefined;
  title: string | undefined;
  src?: string;
}

import * as React from "react";

export class LightBoxExtension {
  private images: LightboxImage[] = [];
  type: "carousel" | "default" = "default";

  constructor(type: "carousel" | "default") {
    this.type = type;
  }

  addImage = (img: LightboxImage) => {
    this.images.push(img);
  };

  removeImage = (img: LightboxImage) => {
    this.images = this.images.filter((item) => item !== img);
  };

  getImages = (): LightboxImage[] => this.images;
}

export const LightBoxContext = React.createContext<LightBoxExtension>(
  new LightBoxExtension("default")
);

export const useLightBoxExtension = (): LightBoxExtension =>
  React.useContext(LightBoxContext);
